<template>
  <el-container direction="vertical">
    <SuperHeader />
    <el-container class="admin-container">
      <SuperSidebar />
      <el-main>
        <router-view v-slot="{ Component }">
          <transition name="fade" mode="out-in">
            <component :is="Component" />
          </transition>
        </router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import SuperHeader from '@/components/layouts/super/Header'
import SuperSidebar from '@/components/layouts/super/Sidebar'
export default {
  name: 'SuperLayout',
  components: {
    SuperHeader,
    SuperSidebar
  }
}
</script>
